import React from 'react';
import { Modal } from 'react-bootstrap';
import '../../../assets/css/dashboard.css';
import TaxForm from '../forms/taxForm/TaxFormLogic';

const Tax = (props) => {
	return (
		<div>
			<Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header closeButton>
					<Modal.Title>
						<h5 className="text-grey text-center">Add Tax</h5>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<TaxForm refetch={props.refetch} />
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default Tax;
